(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5615],{

/***/ 655:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[chain]",
      function () {
        return __webpack_require__(60795);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


/**
 * Renders the <head> section of the HTML page, including meta tags, title, and favicon.
 * @param ogImage - The URL of the Open Graph image to be displayed in social media shares.
 * @param title - The title of the page.
 * @param description - The description of the page.
 */ const Head = (param)=>{
    let { ogImage ="https://publicmarket.app/banner.png" , title ="Public Market" , description ="An open door to the world of nfts"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@lunarmayorxyz"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: ogImage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:determiner",
                content: "the"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: "en"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: ogImage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:type",
                content: "image/png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: "1200"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: "600"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:alt",
                content: "Public Market banner"
            })
        ]
    });
};


/***/ }),

/***/ 53593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21666);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99603);
/* harmony import */ var _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93024);




const SectionTitle = (param)=>/*#__PURE__*/ {
    let { title  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
        style: "subtitle1",
        css: {
            mb: 8
        },
        children: title
    });
};
const SectionLink = (param)=>/*#__PURE__*/ {
    let { name , href  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Anchor */ .ee, {
        target: "_blank",
        rel: "noopener noreferrer",
        href: href,
        weight: "medium",
        css: {
            fontSize: 14,
            mt: 16
        },
        children: name
    });
};
const developerSectionLinks = [
    {
        name: "Intro Blog",
        href: "mirror.xyz"
    },
    {
        name: "Github",
        href: "https://github.com/reservoirprotocol"
    }
];
const companySectionLinks = [
    {
        name: "Terms of Use",
        href: "https://reservoir.tools/terms"
    },
    {
        name: "Privacy Policy",
        href: "https://reservoir.tools/privacy"
    }
];
const Footer = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
        justify: "between",
        css: {
            borderTop: "1px solid $gray7",
            borderStyle: "solid",
            p: "$5",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 36,
            "@bp600": {
                flexDirection: "row",
                gap: 0
            }
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                css: {
                    gap: 80,
                    "@bp600": {
                        gap: 136
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionTitle, {
                                title: "Resources"
                            }),
                            developerSectionLinks.map((props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionLink, {
                                    ...props
                                }, props.name))
                        ]
                    }),
                     false && /*#__PURE__*/ 0
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                direction: "column",
                css: {
                    alignItems: "flex-start",
                    "@bp600": {
                        alignItems: "flex-end"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionTitle, {
                        title: "Come talk to us"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                        css: {
                            gap: "$4",
                            mt: 16
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            rel: "noopener noreferrer",
                            href: "https://twitter.com/lunarmayorxyz",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                size: "xs",
                                color: "gray3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                                    icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_3__/* .faTwitter */ .mdU,
                                    width: 14,
                                    height: 14
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 12623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AW": function() { return /* binding */ DropdownMenuContent; },
/* harmony export */   "Lt": function() { return /* binding */ Dropdown; },
/* harmony export */   "Xi": function() { return /* binding */ DropdownMenuItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var stitches_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50530);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84113);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12664);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21190);





const DropdownMenuContent = (0,stitches_config__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__/* .DropdownMenuContent */ .AW, {
    mx: "$4",
    p: "$2",
    borderRadius: 8,
    zIndex: 5,
    background: "$dropdownBg",
    $$borderColor: "$colors$gray7",
    boxShadow: "0 0 0 1px $$borderColor"
});
const AnimatedDropdownMenuContent = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((param, forwardedRef)=>/*#__PURE__*/ {
    let { children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DropdownMenuContent, {
        asChild: true,
        forceMount: true,
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.div */ .E.div, {
            ref: forwardedRef,
            initial: {
                scale: 0.9,
                opacity: 0,
                y: -20
            },
            animate: {
                scale: 1,
                opacity: 1,
                y: 0,
                transition: {
                    mass: 0.05,
                    type: "spring",
                    duration: 0.1
                }
            },
            exit: {
                y: -20,
                scale: 0.9,
                opacity: 0,
                transition: {
                    duration: 0.1
                }
            },
            children: children
        })
    });
});
const DropdownMenuItem = (0,stitches_config__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__/* .DropdownMenuItem */ .Xi, {
    fontSize: 16,
    fontFamily: "$body",
    color: "$gray12",
    px: "$2",
    py: "$4",
    borderRadius: 8,
    outline: "none",
    cursor: "pointer",
    "&:hover": {
        backgroundColor: "$gray5"
    },
    "&:focus": {
        backgroundColor: "$gray5"
    }
});
const Dropdown = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((param, forwardedRef)=>{
    let { children , trigger , contentProps , ...props } = param;
    const [open, setOpen] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__/* .Root */ .fC, {
        ...props,
        open: open,
        onOpenChange: setOpen,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__/* .Trigger */ .xz, {
                asChild: true,
                children: trigger
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .AnimatePresence */ .M, {
                children: open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AnimatedDropdownMenuContent, {
                    ref: forwardedRef,
                    ...contentProps,
                    children: children
                })
            })
        ]
    });
});



/***/ }),

/***/ 60795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _chain_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/primitives/index.ts + 13 modules
var primitives = __webpack_require__(21666);
// EXTERNAL MODULE: ./components/Layout.tsx
var Layout = __webpack_require__(51943);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/home/Footer.tsx
var Footer = __webpack_require__(53593);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./hooks/index.ts + 6 modules
var hooks = __webpack_require__(25511);
// EXTERNAL MODULE: ./utils/chains.ts
var chains = __webpack_require__(67418);
// EXTERNAL MODULE: ./components/Head.tsx
var Head = __webpack_require__(4049);
// EXTERNAL MODULE: ./context/ChainContextProvider.tsx
var ChainContextProvider = __webpack_require__(43810);
// EXTERNAL MODULE: ./components/primitives/Dropdown.tsx
var Dropdown = __webpack_require__(12623);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(59417);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(99603);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/numbers.ts + 1 modules
var numbers = __webpack_require__(23701);
;// CONCATENATED MODULE: ./components/home/ChainStats.tsx







const ChainStats = ()=>{
    var _statsData_stats;
    const { data: statsData  } = (0,hooks/* useChainStats */.u6)();
    const stats = statsData === null || statsData === void 0 ? void 0 : (_statsData_stats = statsData.stats) === null || _statsData_stats === void 0 ? void 0 : _statsData_stats["7day"];
    const chain = (0,hooks/* useMarketplaceChain */.gw)();
    const statsSections = (0,react.useMemo)(()=>{
        const sections = [
            {
                title: "7d Mints",
                stat: "-",
                icon: free_solid_svg_icons/* faSprout */._ck
            },
            {
                title: "7d Secondary Sales",
                stat: "-",
                icon: free_solid_svg_icons/* faShoppingCart */.sq$
            },
            {
                title: "7d Total Volume",
                stat: "-",
                icon: free_solid_svg_icons/* faImage */.VmB
            }
        ];
        if (stats) {
            sections[0].stat = "".concat(stats.mintCount ? (0,numbers/* formatNumber */.uf)(stats.mintCount) : 0);
            sections[1].stat = "".concat(stats.saleCount ? (0,numbers/* formatNumber */.uf)(stats.saleCount) : 0);
            sections[2].stat = /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                amount: stats.totalVolume,
                textStyle: "h6",
                logoHeight: 14
            });
        }
        return sections;
    }, [
        stats,
        chain
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
        css: {
            gap: 24
        },
        children: statsSections.map((section, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                align: "center",
                css: {
                    border: "1px solid",
                    borderColor: "$gray6",
                    p: "$4",
                    borderRadius: 8,
                    gap: "$4",
                    flex: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: section.icon,
                        width: 25,
                        height: 25,
                        color: "#9BA1A6"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            gap: "$2"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "subtitle2",
                                color: "subtle",
                                children: section.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "h6",
                                children: section.stat
                            })
                        ]
                    })
                ]
            }, i))
    });
};

// EXTERNAL MODULE: ./node_modules/@reservoir0x/reservoir-kit-ui/dist/index.module.js + 197 modules
var index_module = __webpack_require__(9836);
// EXTERNAL MODULE: ./node_modules/swr/core/dist/index.mjs
var dist = __webpack_require__(95591);
// EXTERNAL MODULE: ./node_modules/@reservoir0x/reservoir-sdk/dist/index.module.js
var dist_index_module = __webpack_require__(4495);
;// CONCATENATED MODULE: ./hooks/useTopSellingCollections.ts




/* harmony default export */ function useTopSellingCollections(options) {
    let swrOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, chainId = arguments.length > 2 ? arguments[2] : void 0;
    var _topSellingData_collections;
    const client = (0,index_module/* useReservoirClient */.RW)();
    const chain = chainId !== undefined ? client === null || client === void 0 ? void 0 : client.chains.find((chain)=>chain.id === chainId) : client === null || client === void 0 ? void 0 : client.currentChain();
    const path = new URL("".concat(chain === null || chain === void 0 ? void 0 : chain.baseApiUrl, "/collections/top-selling/v1"));
    if (options) {
        (0,dist_index_module/* setParams */.PX)(path, options);
    }
    const { data: topSellingData , ...topSellingSwr } = (0,dist/* default */.ZP)(path.href ? [
        path.href,
        chain === null || chain === void 0 ? void 0 : chain.apiKey,
        client === null || client === void 0 ? void 0 : client.version
    ] : null, null, swrOptions);
    const ids = topSellingData === null || topSellingData === void 0 ? void 0 : (_topSellingData_collections = topSellingData.collections) === null || _topSellingData_collections === void 0 ? void 0 : _topSellingData_collections.map((collection)=>{
        var _collection_id;
        if ((_collection_id = collection.id) === null || _collection_id === void 0 ? void 0 : _collection_id.includes(":")) {
            return collection.id.split(":")[0];
        }
        return collection.id;
    });
    const { data: collections , isValidating: isValidatingCollections  } = (0,index_module/* useCollections */.bX)(ids && ids.length > 0 ? {
        contract: ids,
        includeMintStages: true
    } : false, swrOptions);
    const collectionsMap = (0,react.useMemo)(()=>{
        return collections.reduce((map, collection)=>{
            map[collection.id] = collection;
            return map;
        }, {});
    }, [
        collections
    ]);
    const combinedCollections = (0,react.useMemo)(()=>{
        var _topSellingData_collections;
        return topSellingData === null || topSellingData === void 0 ? void 0 : (_topSellingData_collections = topSellingData.collections) === null || _topSellingData_collections === void 0 ? void 0 : _topSellingData_collections.map((collection)=>{
            return {
                ...collection,
                ...collectionsMap[collection.id]
            };
        });
    }, [
        collections,
        topSellingData
    ]);
    return {
        ...topSellingSwr,
        collections: collectionsMap,
        data: {
            collections: combinedCollections
        },
        isValidating: isValidatingCollections || !(ids === null || ids === void 0 ? void 0 : ids.length) && !collections.length || topSellingSwr.isValidating
    };
}

// EXTERNAL MODULE: ./components/common/OpenSeaVerified.tsx
var OpenSeaVerified = __webpack_require__(44930);
// EXTERNAL MODULE: ./components/navbar/index.tsx + 9 modules
var navbar = __webpack_require__(42927);
// EXTERNAL MODULE: ./components/primitives/Img.tsx
var Img = __webpack_require__(68916);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./utils/optimizeImage.ts
var optimizeImage = __webpack_require__(77497);
;// CONCATENATED MODULE: ./components/home/ActiveMintTooltip.tsx




const ActiveMintTooltip = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
            style: "body3",
            css: {
                display: "block"
            },
            children: "Actively minting"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
            css: {
                color: "$green10"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                icon: free_solid_svg_icons/* faSeedling */.YKZ
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/home/CollectionTopSellingTable.tsx














const fourTemplateColumns = "1.5fr 1fr 1fr 324px";
const fiveTemplateColumns = "1.6fr 1fr 1fr 1fr 1.6fr";
const CollectionTopSellingTable = (param)=>{
    let { topSellingCollections , collections , loading , fillType  } = param;
    const isSmallDevice = (0,react_responsive.useMediaQuery)({
        maxWidth: 900
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
        direction: "column",
        css: {
            width: "100%",
            pb: "$2"
        },
        children: [
            !isSmallDevice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionTableHeading, {
                fillType: fillType
            }) : null,
            !loading && (topSellingCollections === null || topSellingCollections === void 0 ? void 0 : topSellingCollections.length) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                align: "center",
                css: {
                    py: "$6",
                    gap: "$4",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            color: "$gray11"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_solid_svg_icons/* faMagnifyingGlass */.Y$T,
                            size: "2xl"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            color: "$gray11"
                        },
                        children: "No collections found"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                direction: "column",
                css: {
                    position: "relative"
                },
                children: topSellingCollections === null || topSellingCollections === void 0 ? void 0 : topSellingCollections.map((collection, i)=>{
                    switch(fillType){
                        case "sale":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SaleTableRow, {
                                topSellingCollection: collection,
                                collection: collections[collection.id],
                                rank: i + 1,
                                isSmallDevice: isSmallDevice
                            }, collection.id);
                        case "mint":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MintTableRow, {
                                topSellingCollection: collection,
                                collection: collections[collection.id],
                                rank: i + 1,
                                isSmallDevice: isSmallDevice
                            }, collection.id);
                        case "any":
                        default:
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AllSalesTableRow, {
                                topSellingCollection: collection,
                                collection: collections[collection.id],
                                rank: i + 1,
                                isSmallDevice: isSmallDevice
                            }, collection.id);
                    }
                })
            })
        ]
    });
};
const CollectionCell = (param)=>{
    let { collection , topSellingCollection , rank  } = param;
    var _collection_mintStages;
    const { routePrefix  } = (0,hooks/* useMarketplaceChain */.gw)();
    const mintData = collection === null || collection === void 0 ? void 0 : (_collection_mintStages = collection.mintStages) === null || _collection_mintStages === void 0 ? void 0 : _collection_mintStages.find((stage)=>stage.kind === "public");
    const collectionImage = (0,react.useMemo)(()=>{
        return (0,optimizeImage/* default */.Z)((collection === null || collection === void 0 ? void 0 : collection.image) || (topSellingCollection === null || topSellingCollection === void 0 ? void 0 : topSellingCollection.image), 250);
    }, [
        collection === null || collection === void 0 ? void 0 : collection.image,
        topSellingCollection === null || topSellingCollection === void 0 ? void 0 : topSellingCollection.image
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
        css: {
            minWidth: 0
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/".concat(routePrefix, "/collection/").concat(topSellingCollection.id),
            style: {
                display: "inline-block",
                width: "100%",
                minWidth: 0
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                align: "center",
                css: {
                    gap: "$2",
                    cursor: "pointer",
                    minWidth: 0,
                    overflow: "hidden",
                    width: "100$"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            mr: "$2",
                            width: 15
                        },
                        style: "subtitle3",
                        children: rank
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* default */.Z, {
                        src: collectionImage,
                        css: {
                            borderRadius: 8,
                            width: 56,
                            height: 56,
                            objectFit: "cover"
                        },
                        alt: "Collection Image",
                        width: 56,
                        height: 56,
                        unoptimized: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            display: "inline-block",
                            minWidth: 0
                        },
                        style: "subtitle1",
                        ellipsify: true,
                        children: topSellingCollection === null || topSellingCollection === void 0 ? void 0 : topSellingCollection.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenSeaVerified/* OpenSeaVerified */.v, {
                        openseaVerificationStatus: collection === null || collection === void 0 ? void 0 : collection.openseaVerificationStatus
                    }),
                    mintData ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveMintTooltip, {}) : null
                ]
            })
        })
    });
};
const RecentSalesCell = (param)=>{
    let { collection , topSellingCollection , isSmallDevice  } = param;
    const recentSales = (0,react.useMemo)(()=>{
        var _topSellingCollection_recentSales;
        return topSellingCollection === null || topSellingCollection === void 0 ? void 0 : (_topSellingCollection_recentSales = topSellingCollection.recentSales) === null || _topSellingCollection_recentSales === void 0 ? void 0 : _topSellingCollection_recentSales.slice(0, 5);
    }, [
        topSellingCollection
    ]) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
        css: {
            minWidth: 0,
            pb: (recentSales === null || recentSales === void 0 ? void 0 : recentSales.length) > 0 ? isSmallDevice ? "$4" : "$3" : 0,
            px: isSmallDevice ? 0 : "$3"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
            direction: "column",
            css: {
                gap: "$2"
            },
            children: [
                isSmallDevice && (recentSales === null || recentSales === void 0 ? void 0 : recentSales.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: "Recent Activity"
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                    css: {
                        gap: "$2",
                        overflowX: "auto"
                    },
                    children: recentSales === null || recentSales === void 0 ? void 0 : recentSales.map((sale, idx)=>{
                        var _sale_token, _sale_token1, _sale_token2;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                            open: (sale === null || sale === void 0 ? void 0 : (_sale_token = sale.token) === null || _sale_token === void 0 ? void 0 : _sale_token.name) ? undefined : false,
                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "body3",
                                as: "p",
                                children: sale === null || sale === void 0 ? void 0 : (_sale_token1 = sale.token) === null || _sale_token1 === void 0 ? void 0 : _sale_token1.name
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                css: {
                                    flexShrink: 0
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* default */.Z, {
                                    src: (sale === null || sale === void 0 ? void 0 : (_sale_token2 = sale.token) === null || _sale_token2 === void 0 ? void 0 : _sale_token2.image) || (collection === null || collection === void 0 ? void 0 : collection.image) || "",
                                    alt: "Token Image",
                                    width: 56,
                                    height: 56,
                                    unoptimized: true,
                                    css: {
                                        borderRadius: 8,
                                        width: 56,
                                        height: 56,
                                        objectFit: "cover"
                                    }
                                })
                            })
                        }, idx);
                    })
                })
            ]
        })
    });
};
const AllSalesTableRow = (param)=>{
    let { collection , topSellingCollection , rank , isSmallDevice  } = param;
    var _collection_mintStages, _mintData_price, _mintData_price_amount, _collection_floorAsk, _collection_floorAsk_price, _collection_floorAsk_price_amount, _collection_floorAsk1, _collection_floorAsk_price1, _collection_floorAsk_price_amount1, _collection_floorAsk2, _collection_floorAsk_price2, _collection_floorAsk_price_currency, _collection_floorAsk3, _collection_floorAsk_price3, _collection_floorAsk_price_currency1;
    const mintData = collection === null || collection === void 0 ? void 0 : (_collection_mintStages = collection.mintStages) === null || _collection_mintStages === void 0 ? void 0 : _collection_mintStages.find((stage)=>stage.kind === "public");
    const mintPrice = (mintData === null || mintData === void 0 ? void 0 : (_mintData_price = mintData.price) === null || _mintData_price === void 0 ? void 0 : (_mintData_price_amount = _mintData_price.amount) === null || _mintData_price_amount === void 0 ? void 0 : _mintData_price_amount.decimal) || 0;
    const floorAsk = (collection === null || collection === void 0 ? void 0 : (_collection_floorAsk = collection.floorAsk) === null || _collection_floorAsk === void 0 ? void 0 : (_collection_floorAsk_price = _collection_floorAsk.price) === null || _collection_floorAsk_price === void 0 ? void 0 : (_collection_floorAsk_price_amount = _collection_floorAsk_price.amount) === null || _collection_floorAsk_price_amount === void 0 ? void 0 : _collection_floorAsk_price_amount.native) || 0;
    const { routePrefix  } = (0,hooks/* useMarketplaceChain */.gw)();
    const collectionImage = (0,react.useMemo)(()=>{
        return (0,optimizeImage/* default */.Z)((collection === null || collection === void 0 ? void 0 : collection.image) || (topSellingCollection === null || topSellingCollection === void 0 ? void 0 : topSellingCollection.image), 250);
    }, [
        collection === null || collection === void 0 ? void 0 : collection.image,
        topSellingCollection === null || topSellingCollection === void 0 ? void 0 : topSellingCollection.image
    ]);
    if (isSmallDevice) {
        var _collection_floorAsk4, _collection_floorAsk_price4, _collection_floorAsk_price_amount2, _collection_floorAsk5, _collection_floorAsk_price5, _collection_floorAsk_price_currency2, _collection_floorAsk6, _collection_floorAsk_price6, _collection_floorAsk_price_currency3;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
            css: {
                pt: "$4",
                borderBottom: "1px solid $gray3"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    css: {
                        pt: "$1",
                        mr: "$3",
                        width: 15
                    },
                    style: "subtitle3",
                    children: rank
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    direction: "column",
                    css: {
                        width: "100%",
                        overflow: "hidden"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/".concat(routePrefix, "/collection/").concat(topSellingCollection.id),
                            style: {
                                display: "inline-block",
                                minWidth: 0
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                justify: "between",
                                css: {
                                    gap: "$3"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            cursor: "pointer",
                                            width: "100%",
                                            overflow: "hidden"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* default */.Z, {
                                                src: collectionImage,
                                                css: {
                                                    borderRadius: 8,
                                                    width: 48,
                                                    height: 48,
                                                    objectFit: "cover"
                                                },
                                                alt: "Collection Image",
                                                width: 48,
                                                height: 48,
                                                unoptimized: true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                                css: {
                                                    ml: "$4",
                                                    width: "100%",
                                                    minWidth: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                        align: "center",
                                                        css: {
                                                            gap: "$2",
                                                            mb: 4,
                                                            maxWidth: "80%"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                css: {
                                                                    display: "inline-block"
                                                                },
                                                                style: "subtitle1",
                                                                ellipsify: true,
                                                                children: topSellingCollection === null || topSellingCollection === void 0 ? void 0 : topSellingCollection.name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenSeaVerified/* OpenSeaVerified */.v, {
                                                                openseaVerificationStatus: collection === null || collection === void 0 ? void 0 : collection.openseaVerificationStatus
                                                            }),
                                                            mintData ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveMintTooltip, {}) : null
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                        align: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                css: {
                                                                    mr: "$1",
                                                                    color: "$gray11"
                                                                },
                                                                style: "body3",
                                                                children: "Floor"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                                                amount: collection === null || collection === void 0 ? void 0 : (_collection_floorAsk4 = collection.floorAsk) === null || _collection_floorAsk4 === void 0 ? void 0 : (_collection_floorAsk_price4 = _collection_floorAsk4.price) === null || _collection_floorAsk_price4 === void 0 ? void 0 : (_collection_floorAsk_price_amount2 = _collection_floorAsk_price4.amount) === null || _collection_floorAsk_price_amount2 === void 0 ? void 0 : _collection_floorAsk_price_amount2.decimal,
                                                                address: collection === null || collection === void 0 ? void 0 : (_collection_floorAsk5 = collection.floorAsk) === null || _collection_floorAsk5 === void 0 ? void 0 : (_collection_floorAsk_price5 = _collection_floorAsk5.price) === null || _collection_floorAsk_price5 === void 0 ? void 0 : (_collection_floorAsk_price_currency2 = _collection_floorAsk_price5.currency) === null || _collection_floorAsk_price_currency2 === void 0 ? void 0 : _collection_floorAsk_price_currency2.contract,
                                                                decimals: collection === null || collection === void 0 ? void 0 : (_collection_floorAsk6 = collection.floorAsk) === null || _collection_floorAsk6 === void 0 ? void 0 : (_collection_floorAsk_price6 = _collection_floorAsk6.price) === null || _collection_floorAsk_price6 === void 0 ? void 0 : (_collection_floorAsk_price_currency3 = _collection_floorAsk_price6.currency) === null || _collection_floorAsk_price_currency3 === void 0 ? void 0 : _collection_floorAsk_price_currency3.decimals,
                                                                logoHeight: 16,
                                                                maximumFractionDigits: 2,
                                                                textStyle: "subtitle2"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        direction: "column",
                                        css: {
                                            gap: "$2"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "subtitle3",
                                                color: "subtle",
                                                children: "Sales"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "subtitle3",
                                                children: (0,numbers/* formatNumber */.uf)(topSellingCollection.count)
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, topSellingCollection.id),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentSalesCell, {
                            collection: collection,
                            topSellingCollection: topSellingCollection,
                            isSmallDevice: isSmallDevice
                        })
                    ]
                })
            ]
        });
    } else return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* TableRow */.SC, {
        css: {
            gridTemplateColumns: fourTemplateColumns
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionCell, {
                collection: collection,
                topSellingCollection: topSellingCollection,
                rank: rank
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: mintData && mintPrice < floorAsk ? mintPrice === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle2",
                    children: "Free"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                    amount: mintPrice,
                    textStyle: "subtitle2",
                    logoHeight: 14
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                    amount: collection === null || collection === void 0 ? void 0 : (_collection_floorAsk1 = collection.floorAsk) === null || _collection_floorAsk1 === void 0 ? void 0 : (_collection_floorAsk_price1 = _collection_floorAsk1.price) === null || _collection_floorAsk_price1 === void 0 ? void 0 : (_collection_floorAsk_price_amount1 = _collection_floorAsk_price1.amount) === null || _collection_floorAsk_price_amount1 === void 0 ? void 0 : _collection_floorAsk_price_amount1.decimal,
                    address: collection === null || collection === void 0 ? void 0 : (_collection_floorAsk2 = collection.floorAsk) === null || _collection_floorAsk2 === void 0 ? void 0 : (_collection_floorAsk_price2 = _collection_floorAsk2.price) === null || _collection_floorAsk_price2 === void 0 ? void 0 : (_collection_floorAsk_price_currency = _collection_floorAsk_price2.currency) === null || _collection_floorAsk_price_currency === void 0 ? void 0 : _collection_floorAsk_price_currency.contract,
                    decimals: collection === null || collection === void 0 ? void 0 : (_collection_floorAsk3 = collection.floorAsk) === null || _collection_floorAsk3 === void 0 ? void 0 : (_collection_floorAsk_price3 = _collection_floorAsk3.price) === null || _collection_floorAsk_price3 === void 0 ? void 0 : (_collection_floorAsk_price_currency1 = _collection_floorAsk_price3.currency) === null || _collection_floorAsk_price_currency1 === void 0 ? void 0 : _collection_floorAsk_price_currency1.decimals,
                    textStyle: "subtitle2",
                    logoHeight: 14
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle2",
                    children: (0,numbers/* formatNumber */.uf)(topSellingCollection.count)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentSalesCell, {
                collection: collection,
                topSellingCollection: topSellingCollection,
                isSmallDevice: isSmallDevice
            })
        ]
    }, topSellingCollection.id);
};
const SaleTableRow = (param)=>{
    let { collection , topSellingCollection , rank , isSmallDevice  } = param;
    var _collection_mintStages;
    const { routePrefix  } = (0,hooks/* useMarketplaceChain */.gw)();
    const mintData = collection === null || collection === void 0 ? void 0 : (_collection_mintStages = collection.mintStages) === null || _collection_mintStages === void 0 ? void 0 : _collection_mintStages.find((stage)=>stage.kind === "public");
    const collectionImage = (0,react.useMemo)(()=>{
        return (0,optimizeImage/* default */.Z)((collection === null || collection === void 0 ? void 0 : collection.image) || (topSellingCollection === null || topSellingCollection === void 0 ? void 0 : topSellingCollection.image), 250);
    }, [
        collection === null || collection === void 0 ? void 0 : collection.image,
        topSellingCollection === null || topSellingCollection === void 0 ? void 0 : topSellingCollection.image
    ]);
    if (isSmallDevice) {
        var _collection_floorAsk, _collection_floorAsk_price, _collection_floorAsk_price_amount, _collection_floorAsk1, _collection_floorAsk_price1, _collection_floorAsk_price_currency, _collection_floorAsk2, _collection_floorAsk_price2, _collection_floorAsk_price_currency1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
            css: {
                pt: "$4",
                borderBottom: "1px solid $gray3"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    css: {
                        pt: "$1",
                        mr: "$3",
                        width: 15
                    },
                    style: "subtitle3",
                    children: rank
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    direction: "column",
                    css: {
                        width: "100%",
                        overflow: "hidden"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/".concat(routePrefix, "/collection/").concat(topSellingCollection.id),
                            style: {
                                display: "inline-block",
                                minWidth: 0
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                justify: "between",
                                css: {
                                    gap: "$3"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            cursor: "pointer",
                                            width: "100%",
                                            overflow: "hidden"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* default */.Z, {
                                                src: collectionImage,
                                                css: {
                                                    borderRadius: 8,
                                                    width: 48,
                                                    height: 48,
                                                    objectFit: "cover"
                                                },
                                                alt: "Collection Image",
                                                width: 48,
                                                height: 48,
                                                unoptimized: true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                                css: {
                                                    ml: "$4",
                                                    width: "100%",
                                                    minWidth: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                        align: "center",
                                                        css: {
                                                            gap: "$2",
                                                            mb: 4,
                                                            maxWidth: "80%"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                css: {
                                                                    display: "inline-block"
                                                                },
                                                                style: "subtitle1",
                                                                ellipsify: true,
                                                                children: topSellingCollection === null || topSellingCollection === void 0 ? void 0 : topSellingCollection.name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenSeaVerified/* OpenSeaVerified */.v, {
                                                                openseaVerificationStatus: collection === null || collection === void 0 ? void 0 : collection.openseaVerificationStatus
                                                            }),
                                                            mintData ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveMintTooltip, {}) : null
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                        align: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                css: {
                                                                    mr: "$1",
                                                                    color: "$gray11"
                                                                },
                                                                style: "body3",
                                                                children: "Floor"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                                                amount: collection === null || collection === void 0 ? void 0 : (_collection_floorAsk = collection.floorAsk) === null || _collection_floorAsk === void 0 ? void 0 : (_collection_floorAsk_price = _collection_floorAsk.price) === null || _collection_floorAsk_price === void 0 ? void 0 : (_collection_floorAsk_price_amount = _collection_floorAsk_price.amount) === null || _collection_floorAsk_price_amount === void 0 ? void 0 : _collection_floorAsk_price_amount.decimal,
                                                                address: collection === null || collection === void 0 ? void 0 : (_collection_floorAsk1 = collection.floorAsk) === null || _collection_floorAsk1 === void 0 ? void 0 : (_collection_floorAsk_price1 = _collection_floorAsk1.price) === null || _collection_floorAsk_price1 === void 0 ? void 0 : (_collection_floorAsk_price_currency = _collection_floorAsk_price1.currency) === null || _collection_floorAsk_price_currency === void 0 ? void 0 : _collection_floorAsk_price_currency.contract,
                                                                decimals: collection === null || collection === void 0 ? void 0 : (_collection_floorAsk2 = collection.floorAsk) === null || _collection_floorAsk2 === void 0 ? void 0 : (_collection_floorAsk_price2 = _collection_floorAsk2.price) === null || _collection_floorAsk_price2 === void 0 ? void 0 : (_collection_floorAsk_price_currency1 = _collection_floorAsk_price2.currency) === null || _collection_floorAsk_price_currency1 === void 0 ? void 0 : _collection_floorAsk_price_currency1.decimals,
                                                                logoHeight: 16,
                                                                maximumFractionDigits: 2,
                                                                textStyle: "subtitle2"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        direction: "column",
                                        css: {
                                            gap: "$2"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "subtitle3",
                                                color: "subtle",
                                                children: "Sales"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "subtitle3",
                                                children: (0,numbers/* formatNumber */.uf)(topSellingCollection.count)
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, topSellingCollection.id),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentSalesCell, {
                            collection: collection,
                            topSellingCollection: topSellingCollection,
                            isSmallDevice: isSmallDevice
                        })
                    ]
                })
            ]
        });
    } else {
        var _collection_floorAsk3, _collection_floorAsk_price3, _collection_floorAsk_price_amount1, _collection_floorAsk4, _collection_floorAsk_price4, _collection_floorAsk_price_currency2, _collection_floorAsk5, _collection_floorAsk_price5, _collection_floorAsk_price_currency3;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* TableRow */.SC, {
            css: {
                gridTemplateColumns: fourTemplateColumns
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionCell, {
                    collection: collection,
                    topSellingCollection: topSellingCollection,
                    rank: rank
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                        amount: collection === null || collection === void 0 ? void 0 : (_collection_floorAsk3 = collection.floorAsk) === null || _collection_floorAsk3 === void 0 ? void 0 : (_collection_floorAsk_price3 = _collection_floorAsk3.price) === null || _collection_floorAsk_price3 === void 0 ? void 0 : (_collection_floorAsk_price_amount1 = _collection_floorAsk_price3.amount) === null || _collection_floorAsk_price_amount1 === void 0 ? void 0 : _collection_floorAsk_price_amount1.decimal,
                        address: collection === null || collection === void 0 ? void 0 : (_collection_floorAsk4 = collection.floorAsk) === null || _collection_floorAsk4 === void 0 ? void 0 : (_collection_floorAsk_price4 = _collection_floorAsk4.price) === null || _collection_floorAsk_price4 === void 0 ? void 0 : (_collection_floorAsk_price_currency2 = _collection_floorAsk_price4.currency) === null || _collection_floorAsk_price_currency2 === void 0 ? void 0 : _collection_floorAsk_price_currency2.contract,
                        decimals: collection === null || collection === void 0 ? void 0 : (_collection_floorAsk5 = collection.floorAsk) === null || _collection_floorAsk5 === void 0 ? void 0 : (_collection_floorAsk_price5 = _collection_floorAsk5.price) === null || _collection_floorAsk_price5 === void 0 ? void 0 : (_collection_floorAsk_price_currency3 = _collection_floorAsk_price5.currency) === null || _collection_floorAsk_price_currency3 === void 0 ? void 0 : _collection_floorAsk_price_currency3.decimals,
                        textStyle: "subtitle2",
                        logoHeight: 14
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        style: "subtitle2",
                        children: (0,numbers/* formatNumber */.uf)(topSellingCollection.count)
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentSalesCell, {
                    collection: collection,
                    topSellingCollection: topSellingCollection,
                    isSmallDevice: isSmallDevice
                })
            ]
        }, topSellingCollection.id);
    }
};
const MintTableRow = (param)=>{
    let { collection , topSellingCollection , rank , isSmallDevice  } = param;
    var _collection_mintStages, _mintData_price, _mintData_price_amount;
    const { routePrefix  } = (0,hooks/* useMarketplaceChain */.gw)();
    const mintData = collection === null || collection === void 0 ? void 0 : (_collection_mintStages = collection.mintStages) === null || _collection_mintStages === void 0 ? void 0 : _collection_mintStages.find((stage)=>stage.kind === "public");
    const mintPrice = (mintData === null || mintData === void 0 ? void 0 : (_mintData_price = mintData.price) === null || _mintData_price === void 0 ? void 0 : (_mintData_price_amount = _mintData_price.amount) === null || _mintData_price_amount === void 0 ? void 0 : _mintData_price_amount.decimal) || 0;
    const collectionImage = (0,react.useMemo)(()=>{
        return (0,optimizeImage/* default */.Z)((collection === null || collection === void 0 ? void 0 : collection.image) || (topSellingCollection === null || topSellingCollection === void 0 ? void 0 : topSellingCollection.image), 250);
    }, [
        collection === null || collection === void 0 ? void 0 : collection.image,
        topSellingCollection === null || topSellingCollection === void 0 ? void 0 : topSellingCollection.image
    ]);
    if (isSmallDevice) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
            css: {
                pt: "$4",
                borderBottom: "1px solid $gray3"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    css: {
                        pt: "$1",
                        mr: "$3",
                        width: 15
                    },
                    style: "subtitle3",
                    children: rank
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    direction: "column",
                    css: {
                        width: "100%",
                        overflow: "hidden"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/".concat(routePrefix, "/collection/").concat(topSellingCollection.id),
                            style: {
                                display: "inline-block",
                                minWidth: 0
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                justify: "between",
                                css: {
                                    gap: "$3"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            cursor: "pointer",
                                            width: "100%",
                                            overflow: "hidden"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* default */.Z, {
                                                src: collectionImage,
                                                css: {
                                                    borderRadius: 8,
                                                    width: 48,
                                                    height: 48,
                                                    objectFit: "cover"
                                                },
                                                alt: "Collection Image",
                                                width: 48,
                                                height: 48,
                                                unoptimized: true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                                css: {
                                                    ml: "$4",
                                                    width: "100%",
                                                    minWidth: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                        align: "center",
                                                        css: {
                                                            gap: "$2",
                                                            mb: 4,
                                                            maxWidth: "80%"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                css: {
                                                                    display: "inline-block"
                                                                },
                                                                style: "subtitle1",
                                                                ellipsify: true,
                                                                children: topSellingCollection === null || topSellingCollection === void 0 ? void 0 : topSellingCollection.name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenSeaVerified/* OpenSeaVerified */.v, {
                                                                openseaVerificationStatus: collection === null || collection === void 0 ? void 0 : collection.openseaVerificationStatus
                                                            }),
                                                            mintData ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveMintTooltip, {}) : null
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                        align: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                css: {
                                                                    mr: "$1",
                                                                    color: "$gray11"
                                                                },
                                                                style: "body3",
                                                                children: "Mint Price"
                                                            }),
                                                            mintData ? mintPrice === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                style: "body3",
                                                                children: "Free"
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                                                amount: mintPrice,
                                                                textStyle: "body3",
                                                                logoHeight: 14
                                                            }) : "-"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        direction: "column",
                                        css: {
                                            gap: "$2"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "subtitle3",
                                                color: "subtle",
                                                children: "Sales"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "subtitle3",
                                                children: (0,numbers/* formatNumber */.uf)(topSellingCollection.count)
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, topSellingCollection.id),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentSalesCell, {
                            collection: collection,
                            topSellingCollection: topSellingCollection,
                            isSmallDevice: isSmallDevice
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* TableRow */.SC, {
        css: {
            gridTemplateColumns: fourTemplateColumns
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionCell, {
                collection: collection,
                topSellingCollection: topSellingCollection,
                rank: rank
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: mintData ? mintPrice === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle2",
                    children: "Free"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                    amount: mintPrice,
                    textStyle: "subtitle2",
                    logoHeight: 14
                }) : "-"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle2",
                    children: (0,numbers/* formatNumber */.uf)(topSellingCollection.count)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentSalesCell, {
                collection: collection,
                topSellingCollection: topSellingCollection,
                isSmallDevice: isSmallDevice
            })
        ]
    }, topSellingCollection.id);
};
const anyHeadings = [
    "Collection",
    "Floor Price (Including Mints)",
    "Sales",
    "Recent Activity"
];
const mintHeadings = [
    "Collection",
    "Mint Price",
    "Sales",
    "Recent Activity"
];
const saleHeadings = [
    "Collection",
    "Floor Price",
    "Sales",
    "Recent Activity"
];
const CollectionTableHeading = (param)=>{
    let { fillType  } = param;
    let headings;
    let columns;
    switch(fillType){
        case "mint":
            headings = mintHeadings;
            columns = fourTemplateColumns;
            break;
        case "sale":
            headings = saleHeadings;
            columns = fourTemplateColumns;
            break;
        case "any":
        default:
            headings = anyHeadings;
            columns = fourTemplateColumns;
            break;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* HeaderRow */.VJ, {
        css: {
            display: "none",
            "@md": {
                display: "grid"
            },
            gridTemplateColumns: columns,
            position: "sticky",
            top: navbar/* NAVBAR_HEIGHT */.ik,
            backgroundColor: "$neutralBg",
            zIndex: 1
        },
        children: headings.map((heading)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: heading
                })
            }, heading))
    });
};

;// CONCATENATED MODULE: ./components/home/FillTypeToggle.tsx








const fillTypesFilters = [
    {
        value: "sale",
        display: "Trades"
    },
    {
        value: "mint",
        display: "Mints"
    },
    {
        value: "any",
        display: "All Sales"
    }
];
const FillTypeToggle = (param)=>{
    let { fillType , setFillType  } = param;
    const isMounted = (0,hooks/* useMounted */.s4)();
    const isSmallDevice = (0,react_responsive.useMediaQuery)({
        maxWidth: 905
    }) && isMounted;
    const displayFillType = (0,react.useMemo)(()=>{
        const currentFillType = fillTypesFilters.find((fillTypeFilter)=>fillTypeFilter.value === fillType);
        return currentFillType === null || currentFillType === void 0 ? void 0 : currentFillType.display;
    }, [
        fillTypesFilters,
        fillType
    ]);
    if (isSmallDevice) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Dropdown */.Lt, {
            contentProps: {
                sideOffset: 8,
                style: {
                    minWidth: 120
                }
            },
            trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Button */.zx, {
                color: "gray3",
                css: {
                    px: "14px",
                    justifyContent: "space-between",
                    minWidth: 120,
                    "@md": {
                        width: "220px",
                        minWidth: "max-content",
                        px: "$4"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        style: "body1",
                        children: displayFillType
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                        css: {
                            color: "$gray10",
                            transition: "transform",
                            "[data-state=open] &": {
                                transform: "rotate(180deg)"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_solid_svg_icons/* faChevronDown */.ptq,
                            width: 16
                        })
                    })
                ]
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                direction: "column",
                css: {
                    width: "100%"
                },
                children: fillTypesFilters.map((fillType)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* DropdownMenuItem */.Xi, {
                        onClick: ()=>{
                            setFillType(fillType.value);
                        },
                        css: {
                            py: "$2"
                        },
                        children: fillType.display
                    }, fillType.value))
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* ToggleGroup */.tX, {
        type: "single",
        value: fillType,
        onValueChange: (value)=>setFillType(value),
        css: {
            flexShrink: 0
        },
        children: fillTypesFilters.map((fillType)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* ToggleGroupItem */.GX, {
                value: fillType.value,
                css: {
                    minWidth: 160,
                    p: "$4"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle1",
                    children: fillType.display
                })
            }, fillType.value))
    });
};

;// CONCATENATED MODULE: ./components/home/TimeFilterToggle.tsx








const filterTimes = [
    {
        value: "5",
        display: "5m"
    },
    {
        value: "30",
        display: "30m"
    },
    {
        value: "60",
        display: "1h"
    },
    {
        value: "360",
        display: "6h"
    },
    {
        value: "1440",
        display: "24h"
    }
];
const TimeFilterToggle = (param)=>{
    let { minutesFilter , setMinutesFilter  } = param;
    const isMounted = (0,hooks/* useMounted */.s4)();
    const isSmallDevice = (0,react_responsive.useMediaQuery)({
        maxWidth: 905
    }) && isMounted;
    const displayTime = (0,react.useMemo)(()=>{
        const timeFilter = filterTimes.find((time)=>Number(time.value) === minutesFilter);
        return timeFilter === null || timeFilter === void 0 ? void 0 : timeFilter.display;
    }, [
        filterTimes,
        minutesFilter
    ]);
    if (isSmallDevice) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Dropdown */.Lt, {
            contentProps: {
                sideOffset: 8,
                style: {
                    minWidth: 120
                }
            },
            trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Button */.zx, {
                color: "gray3",
                css: {
                    px: "14px",
                    justifyContent: "space-between",
                    minWidth: 120,
                    "@md": {
                        width: "220px",
                        minWidth: "max-content",
                        px: "$4"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        style: "body1",
                        children: displayTime
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                        css: {
                            color: "$gray10",
                            transition: "transform",
                            "[data-state=open] &": {
                                transform: "rotate(180deg)"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_solid_svg_icons/* faChevronDown */.ptq,
                            width: 16
                        })
                    })
                ]
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                direction: "column",
                css: {
                    width: "100%"
                },
                children: filterTimes.map((time)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* DropdownMenuItem */.Xi, {
                        onClick: ()=>{
                            setMinutesFilter(+time.value);
                        },
                        css: {
                            py: "$2"
                        },
                        children: time.display
                    }, time.value))
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* ToggleGroup */.tX, {
        type: "single",
        value: "".concat(minutesFilter),
        onValueChange: (value)=>setMinutesFilter(+value),
        css: {
            flexShrink: 0
        },
        children: filterTimes.map((time)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* ToggleGroupItem */.GX, {
                value: time.value,
                css: {
                    minWidth: 80,
                    p: "$4"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle1",
                    children: time.display
                })
            }, time.value))
    });
};

;// CONCATENATED MODULE: ./pages/[chain]/index.tsx



















const IndexPage = (param)=>{
    let { ssr  } = param;
    const isSSR = "object" === "undefined";
    const isMounted = (0,hooks/* useMounted */.s4)();
    const isSmallDevice = (0,react_responsive.useMediaQuery)({
        maxWidth: 905
    }) && isMounted;
    const marketplaceChain = (0,hooks/* useMarketplaceChain */.gw)();
    const router = (0,next_router.useRouter)();
    const [fillType, setFillType] = (0,react.useState)("sale");
    const [minutesFilter, setMinutesFilter] = (0,react.useState)(1440);
    const { chain , switchCurrentChain  } = (0,react.useContext)(ChainContextProvider/* ChainContext */.p);
    const startTime = (0,react.useMemo)(()=>{
        const now = new Date();
        const timestamp = Math.floor(now.getTime() / 1000);
        return timestamp - minutesFilter * 60;
    }, [
        minutesFilter
    ]);
    const { data: topSellingCollectionsData , collections: collectionsData , isValidating  } = useTopSellingCollections({
        startTime,
        fillType,
        limit: 20,
        includeRecentSales: true
    }, {
        revalidateOnMount: true,
        refreshInterval: 300000,
        fallbackData: [
            ssr.topSellingCollections[marketplaceChain.id].collections
        ]
    }, chain === null || chain === void 0 ? void 0 : chain.id);
    const [topSellingCollections, setTopSellingCollections] = (0,react.useState)();
    const [collections, setCollections] = (0,react.useState)(collectionsData);
    (0,react.useEffect)(()=>{
        if (!isValidating) {
            setTopSellingCollections(topSellingCollectionsData);
            setCollections(collectionsData);
        }
    }, [
        isValidating
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                css: {
                    p: 24,
                    height: "100%",
                    "@bp800": {
                        p: "$6"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            mx: "auto",
                            maxWidth: 728,
                            pt: "$5",
                            textAlign: "center",
                            alignItems: "flex-start",
                            "@bp600": {
                                alignItems: "center"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                css: {
                                    mb: "$4",
                                    gap: "$3",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    maxWidth: "100%",
                                    "@bp600": {
                                        flexDirection: "row",
                                        alignItems: "center"
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "h3",
                                        css: {
                                            flexShrink: 0
                                        },
                                        children: "Explore NFTs"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        css: {
                                            gap: "$3",
                                            maxWidth: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "h3",
                                                color: "subtle",
                                                children: "on"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Dropdown */.Lt, {
                                                contentProps: {
                                                    sideOffset: 8,
                                                    asChild: true,
                                                    style: {
                                                        margin: 0
                                                    }
                                                },
                                                trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                    css: {
                                                        gap: "$3",
                                                        alignItems: "center",
                                                        cursor: "pointer",
                                                        minWidth: 0
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/home/logos/".concat(marketplaceChain.routePrefix, "-logo.png"),
                                                            alt: "".concat(marketplaceChain.name, " Logo"),
                                                            style: {
                                                                width: 40,
                                                                height: 40
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                            style: "h3",
                                                            ellipsify: true,
                                                            children: " " + marketplaceChain.name
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                            css: {
                                                                color: "$gray10",
                                                                transition: "transform",
                                                                "[data-state=open] &": {
                                                                    transform: "rotate(180deg)"
                                                                }
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                icon: free_solid_svg_icons/* faChevronDown */.ptq,
                                                                width: 16
                                                            })
                                                        })
                                                    ]
                                                }),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                                    direction: "column",
                                                    css: {
                                                        minWidth: 150
                                                    },
                                                    children: chains/* default.map */.ZP.map((param)=>/*#__PURE__*/ {
                                                        let { name , id , routePrefix  } = param;
                                                        return (0,jsx_runtime.jsx)(Dropdown/* DropdownMenuItem */.Xi, {
                                                            css: {
                                                                textAlign: "left",
                                                                py: "$2"
                                                            },
                                                            onClick: ()=>{
                                                                switchCurrentChain(id);
                                                                router.replace(routePrefix, undefined, {
                                                                    scroll: false,
                                                                    shallow: true
                                                                });
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                style: "h6",
                                                                color: id === marketplaceChain.id ? undefined : "subtle",
                                                                css: {
                                                                    cursor: "pointer"
                                                                },
                                                                children: name
                                                            })
                                                        }, id);
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "body1",
                                color: "subtle",
                                css: {
                                    mb: 48,
                                    textAlign: "left"
                                },
                                children: "Multi-Chain Explorer, powered by Reservoir"
                            })
                        ]
                    }),
                    !isSmallDevice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChainStats, {}) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        css: {
                            mb: "$6",
                            "@sm": {
                                my: "$6"
                            },
                            gap: 32
                        },
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                justify: "between",
                                align: "center",
                                css: {
                                    gap: "$2"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FillTypeToggle, {
                                        fillType: fillType,
                                        setFillType: setFillType
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeFilterToggle, {
                                        minutesFilter: minutesFilter,
                                        setMinutesFilter: setMinutesFilter
                                    })
                                ]
                            }),
                            isSSR || !isMounted ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionTopSellingTable, {
                                topSellingCollections: topSellingCollections === null || topSellingCollections === void 0 ? void 0 : topSellingCollections.collections,
                                collections: collections,
                                loading: isValidating,
                                fillType: fillType
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* Footer */.$, {})
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _chain_ = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,3160,3334,1943,9774,2888,179], function() { return __webpack_exec__(655); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);